<template>
  <v-toolbar v-if="$route?.meta?.preview" color="primary" style="z-index: 2">
    <v-toolbar-title class="text-wrap text-center my-auto">
      This is a preview of your survey (voting data will not be saved). You can
      share this preview link with teammates.
    </v-toolbar-title>
  </v-toolbar>
  <div class="fill-height" style="background-color: white">
    <router-view v-slot="{ Component }">
      <CustomTransition
        enter-active-class="slide-in-bottom"
        leave-active-class="slide-out-top"
        mode="out-in"
      >
        <component :is="Component" />
      </CustomTransition>
    </router-view>
    <survey-loader :loading="loading" />
  </div>
  <survey-footer />
</template>

<script lang="ts" setup>
import SurveyFooter from '@/views/Survey/SurveyFooter.vue';
import { computed, onMounted, ref } from 'vue';
import SurveyLoader from './SurveyLoader.vue';
import { useSubmissionStore } from '@/stores/submission';
import CustomTransition from '@/components/CustomTransition.vue';
import { useMessageBoxStore } from '@/stores/messageBox';
import { useRoute } from 'vue-router';

const messageBoxStore = useMessageBoxStore();
const submissionStore = useSubmissionStore();

const loading = ref(false);

const route = useRoute();

const publicId = computed(() => route.params.id as string);

onMounted(async () => {
  loading.value = true;
  if (!submissionStore.initializationTime || submissionStore.submitted) {
    await submissionStore.findOne(publicId.value);
  } else if (submissionStore.hasTimedOut) {
    messageBoxStore.messageBox({
      title: 'Survey Timed Out',
      text: 'Your survey session has timed out, you will need to restart the survey ',
    });
    await submissionStore.findOne(publicId.value);
  } else {
    submissionStore.goToSurveyHome();
  }
  loading.value = false;
});
</script>

<style>
body {
  overflow: -moz-scrollbars-none;
  -ms-overflow-style: none;
}

body::-webkit-scrollbar {
  display: none;
}

.slide-out-top {
  animation: slide-out-top 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

.slide-in-bottom {
  animation: slide-in-bottom 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.slide-in-top {
  animation: slide-in-top 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}

.slide-out-bottom {
  animation: slide-out-bottom 0.3s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
}

@keyframes slide-in-bottom {
  0% {
    transform: translateY(1000px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes slide-out-bottom {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(1000px);
    opacity: 0;
  }
}

@keyframes slide-out-top {
  0% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(-1000px);
    opacity: 0;
  }
}

@keyframes slide-in-top {
  0% {
    transform: translateY(-1000px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}
</style>
